(function () {
  'use strict';

  function initSiblings() {
    const items = document.querySelectorAll('.product-siblings__item');
    if (!items.length) return;

    items.forEach(function (item) {
      item.addEventListener('click', handleSiblingClick);
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleSiblingClick.call(item);
        }
      });
    });
  }

  function handleSiblingClick() {
    const url = this.dataset.url;
    const isActive = this.classList.contains('product-siblings__item--active');

    // Bereits aktiv → nichts tun
    if (isActive) return;

    // Zur Sibling-URL navigieren
    window.location.href = url;
  }

  document.addEventListener('DOMContentLoaded', initSiblings);
})();
